module.exports = __webpack_public_path__ + "img/leg2.87c3e0f7.png";